import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "facetFilter" }
const _hoisted_2 = { class: "filterLabel" }
const _hoisted_3 = { class: "filterLabel" }
const _hoisted_4 = { class: "divFacetList w-100" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "facetOption border-0"
}
const _hoisted_7 = ["data-action"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "8",
  viewBox: "0 0 13 8",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M6.49974 5.05937L11.4497 0.109375L12.8637 1.52338L6.49974 7.88737L0.135742 1.52338L1.54974 0.109375L6.49974 5.05937Z",
    fill: "#006FA6"
  })
], -1)
const _hoisted_9 = {
  key: 1,
  class: "facetOption border-0"
}
const _hoisted_10 = ["data-action"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "8",
  viewBox: "0 0 14 8",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.00026 2.94062L2.05026 7.89062L0.636258 6.47662L7.00026 0.112625L13.3643 6.47662L11.9503 7.89062L7.00026 2.94062Z",
    fill: "#006FA6"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FacetListItem = _resolveComponent("FacetListItem")!

  return (_openBlock(), _createBlock(_Transition, { name: "slide" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.label), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getFirstDealerships(_ctx.numberOfDealershipsToDisplay), (dealership) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `dealership-row-${dealership.dealerId}`,
              onClick: ($event: any) => (_ctx.handleDealershipSelect(dealership.dealerId))
            }, [
              _createVNode(_component_FacetListItem, {
                item: { name: dealership.storeName || '', value: 0 },
                isSelected: _ctx.selectedStores.includes(dealership.dealerId || ''),
                isCheckboxDisabled: _ctx.isCheckboxDisabled(dealership.dealerId),
                "data-action-select-filter": dealership.storeName
              }, {
                leftContent: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(dealership.storeName), 1)
                ]),
                rightContent: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(Math.round(dealership.distance || 0).toLocaleString()) + " mi", 1)
                ]),
                _: 2
              }, 1032, ["item", "isSelected", "isCheckboxDisabled", "data-action-select-filter"])
            ], 8, _hoisted_5))
          }), 128))
        ]),
        (_ctx.displayMoreDealershipsButton)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("a", {
                href: "javascript:void(0)",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMoreDealerships())),
                class: "showMore mx-auto",
                "data-action": _ctx.showMoreText
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.showMoreText), 1),
                _hoisted_8
              ], 8, _hoisted_7)
            ]))
          : _createCommentVNode("", true),
        (_ctx.displayLessDealershipsButton)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("a", {
                href: "javascript:void(0)",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showLessDealerships())),
                class: "showMore mx-auto",
                "data-action": _ctx.showLessText
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.showLessText), 1),
                _hoisted_11
              ], 8, _hoisted_10)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}